import React from "react";
import SearchResultPage from "../../../templates/search-results-template";

const SearchResultResiSales = (props) => {

    const fullpath = props.location.pathname
    const location = props.location
    const fullpathone = props.location

    return (
        <React.Fragment>
            <SearchResultPage 
                locationname="/property/for-sale/" 
                pcategorytype={["residential"]} 
                // multipcategorytype = {['residential']}
                ptype="sales" 
                ptypetag="" 
                pstatustype={["For Sale", "Sale Agreed", "Sold"]}
                fullpathone={fullpathone} 
                fullpathname={fullpath}
                {...props}
            />
        </React.Fragment>
    );
};

export default SearchResultResiSales;
